import { OnDemand } from '@/helpers/onDemand'

export default ({
  store,
  $posthog
}, inject) => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    init_href: window.location.href
  })

  window.uetq = window.uetq || []

  function gtag () {
    window.dataLayer.push(arguments)
  }

  if (!window.location.href.includes('localhost')) {
    gtag('consent', 'default', {
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      ad_storage: 'denied',
      analytics_storage: 'denied',
      wait_for_update: 500
    })
  }

  const loader = new OnDemand('https://mtr.caravanmarkt24.de/gtm.js?id=GTM-MNV56KJ')

  inject('gtm', {

    init (customerData) {
      if (customerData) {
        window.dataLayer.push(customerData)
        try {
          window.uetq.push('set', {
            pid: {
              em: customerData.customerEmail,
              ph: customerData.customerPhone
            }
          })
        } catch (e) {
          console.error('Error setting uetq pid', e)
        }
      }

      window.dataLayer.push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js'
      })
      loader.load(() => {
      })
    },

    push (event) {
      window.dataLayer.push(event)

      try {
        // if event.event exists and is not empty and window.uetq is not empty
        // push event to window.uetq (remove event.event from event)
        // and if currency and value are present, then rename value into revenue_value
        if (event.event && event.event !== '' && window.uetq) {
          const newEvent = { ...event }
          delete newEvent.event
          if (newEvent.currency && newEvent.value) {
            newEvent.revenue_value = newEvent.value
            delete newEvent.value
          }
          window.uetq.push('event', event.event, newEvent)
        }
      } catch (e) {
        console.warn(e)
      }

      try {
        if (event.event && event.event !== '' && window.uetq) {
          const newEvent = { ...event }
          delete newEvent.event
          // console.log('capturing PostHog event', event.event, newEvent)
          $posthog.capture(event.event, newEvent)
        }
      } catch (e) {
        console.log('PostHog capture error', e)
      }
    }

  })
}
